<template>
  <div>
    <button
      v-if="canUserEdit"
      v-b-modal="'editGroupedRuleConfiguration' + ruleGroup.id"
      v-b-tooltip.hide-overflow
      class="btn btn-primary smallActionButton float-right mr-1"
      placement="bottom"
      title="Regelgruppierung-Konfiguration bearbeiten"
      type="button"
      @click="loadGroupedConfiguration"
    >
      <i class="fas fa-cog" />
    </button>
    <b-modal
      :id="'editGroupedRuleConfiguration' + ruleGroup.id"
      :ref="'editGroupedRuleConfiguration' + ruleGroup.id"
      hide-footer
      no-fade
      size="xl"
      title="Gruppierung bearbeiten"
    >
      <div class="d-block mb-4 groupedRuleConfigurationWrapper">
        <u-error-handling
          v-if="errorObject"
          :error-object="errorObject"
        />
        <u-loader v-if="isLoading" />
        <div v-else>
          <div class="row">
            <div class="col-3 font-weight-bold p-4">
              Name
            </div>
            <div
              v-if="groupedRuleConfig"
              class="col-9"
            >
              <v-text-field
                v-model="groupedRuleConfig.name"
                @change="groupdRuleConfigChanged = !groupdRuleConfigChanged"
              />
            </div>
          </div>
          <div
            v-for="(configEntry, index) in configuration.configEntries"
            :key="index"
            class="row"
          >
            <template v-if="configEntry.criteriaStructureId">
              <div class="col-3 mt-4">
                <label>
                  <input
                    :checked="
                      groupedRuleConfig && groupedRuleConfig.groupEntries
                        ? groupedRuleConfig.groupEntries.filter((entry) => {
                          return (
                            entry.criteriaStructureId ==
                            configEntry.criteriaStructureId
                          );
                        }).length > 0
                        : false
                    "
                    name="check"
                    type="checkbox"
                    @change="checkBoxChanged(configEntry)"
                  >
                  <span class="label-text">
                    {{ configEntry.criteriaStructure.name }}</span>
                </label>
              </div>
              <div
                v-show="
                  groupedRuleConfig && groupedRuleConfig.groupEntries
                    ? groupedRuleConfig.groupEntries.filter((entry) => {
                      return (
                        entry.criteriaStructureId ==
                        configEntry.criteriaStructureId
                      );
                    }).length > 0
                    : false
                "
                class="col-9"
              >
                <rule-criteria-autocomplete
                  v-model="groupedRuleConfig"
                  :all-values="groupedRuleConfig"
                  :contract-id="contractId"
                  :edition-id="editionId"
                  :structure-item="configEntry"
                  :title-updated="groupdRuleConfigChanged"
                  :version-number="versionId"
                  collection-name="groupEntries"
                />
              </div>
            </template>
            <template v-if="configEntry.criteriaGroupId">
              <div class="col-3 mt-4">
                <label>
                  <input
                    :checked="
                      groupedRuleConfig && groupedRuleConfig.groupEntries
                        ? groupedRuleConfig.groupEntries.filter((entry) => {
                          return (
                            entry.criteriaGroupId ==
                            configEntry.criteriaGroupId
                          );
                        }).length > 0
                        : false
                    "
                    name="check"
                    type="checkbox"
                    @change="checkBoxChanged(configEntry)"
                  >
                  <span class="label-text">
                    {{ configEntry.criteriaGroup.name }}</span>
                </label>
              </div>
              <div
                v-if="
                  groupedRuleConfig && groupedRuleConfig.groupEntries
                    ? groupedRuleConfig.groupEntries.filter((entry) => {
                      return (
                        entry.criteriaGroupId == configEntry.criteriaGroupId
                      );
                    }).length > 0
                    : false
                "
                class="col-9"
              >
                <v-select
                  v-if="
                    groupedRuleConfig.groupEntries.filter((entry) => {
                      return (
                        entry.criteriaGroupId == configEntry.criteriaGroupId
                      );
                    })[0]
                  "
                  v-model="
                    groupedRuleConfig.groupEntries.filter((entry) => {
                      return (
                        entry.criteriaGroupId == configEntry.criteriaGroupId
                      );
                    })[0].value
                  "
                  :items="
                    GetValuesForGroupings(
                      groupings,
                      configEntry.criteriaGroupId,
                    )
                  "
                  item-text="value"
                  item-value="value"
                />
              </div>
            </template>
            <!-- Variable are not allowed to be set in grouped rules -->
            <!-- <div v-if="configEntry.variableId"></div> -->
          </div>
        </div>
        <u-error-handling
          v-if="deleteErrorObject"
          :error-object="deleteErrorObject"
        />
      </div>
      <b-button
        variant="success"
        @click="saveGroupedRuleSettings"
      >
        Speichern
      </b-button>
      <b-button
        class="ml-2"
        variant="danger"
        @click="hideModal('editGroupedRuleConfiguration' + ruleGroup.id)"
      >
        Abbrechen
      </b-button>
    </b-modal>
  </div>
</template>

<script>
import {
  GetGroupedRuleConfiguration,
  SaveGroupedRuleConfiguration,
} from "@/services/minimum.wage.services/rules.minimum.wages.js";
import { GetValuesForGroupings } from "@/helpers/MinimumWageRulesHelper.js";
import RuleCriteriaAutocomplete from "@/components/minimum.wage/pages/Rules/RuleCriteriaAutocomplete.vue";
import { MinimumWageMixin } from "@/components/minimum.wage/mixins/MinimumWageMixin";

export default {
  components: {
    RuleCriteriaAutocomplete,
  },
  mixins: [MinimumWageMixin],
  props: {
    ruleGroup: {
      type: Object,
      required: true,
    },
    configuration: {
      type: Object,
      required: true,
    },
    contractId: {
      type: String,
      default: "",
    },
    versionId: {
      type: Number,
      default: 0,
    },
    editionId: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isLoading: false,
      errorObject: null,
      groupedRuleConfig: null,
      deleteErrorObject: null,
      groupdRuleConfigChanged: false,
      GetValuesForGroupings: GetValuesForGroupings,
      groupings: this.$store.state.mindestLohnKonfiguration.Groupings,
    };
  },
  methods: {
    hideModal(modalId) {
      this.$refs[modalId].hide();
    },
    loadGroupedConfiguration() {
      this.isLoading = true;
      this.errorObject = null;

      GetGroupedRuleConfiguration(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        this.ruleGroup.id,
        (response) => {
          this.groupedRuleConfig = response;
          this.isLoading = false;
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    saveGroupedRuleSettings() {
      this.isLoading = true;
      SaveGroupedRuleConfiguration(
        this.contractId,
        this.versionId,
        this.editionId,
        this.configuration.id,
        this.ruleGroup.id,
        this.groupedRuleConfig,
        () => {
          this.isLoading = false;
          this.$emit("updated");
          this.hideModal("editGroupedRuleConfiguration" + this.ruleGroup.id);
        },
        (error) => {
          this.isLoading = false;
          this.errorObject = error;
        },
      );
    },
    checkBoxChanged(configEntry) {
      var checked =
        this.groupedRuleConfig && this.groupedRuleConfig.groupEntries
          ? this.groupedRuleConfig.groupEntries.filter((entry) => {
              return (
                entry.criteriaStructureId == configEntry.criteriaStructureId
              );
            }).length > 0
          : false;
      var newChecked = !checked;

      if (newChecked) {
        // add new item
        this.groupedRuleConfig.groupEntries.push({
          id: 0,
          ruleGroupId: this.ruleGroup.id,
          criteriaStructureId: configEntry.criteriaStructureId,
          criteriaGroupId: configEntry.criteriaGroupId,
          variableId: null,
          value: "",
          criteriaListEntryId: null,
        });
      } else {
        var itemToRemoveIndex = this.groupedRuleConfig.groupEntries.indexOf(
          this.groupedRuleConfig.groupEntries.filter((entry) => {
            return (
              entry.criteriaGroupId == configEntry.criteriaGroupId &&
              entry.criteriaStructureId == configEntry.criteriaStructureId
            );
          })[0],
        );
        this.groupedRuleConfig.groupEntries.splice(itemToRemoveIndex, 1);
      }

      this.groupdRuleConfigChanged = !this.groupdRuleConfigChanged;
    },
  },
};
</script>

<style>
input[type="checkbox"] + .label-text:before {
  font-weight: normal;
}

.groupedRuleConfigurationWrapper .label-text {
  padding: 8px;
  font-weight: bold;
}
</style>

<style scoped>
.smallActionButton {
  width: 30px;
  height: 30px;
  padding: 1px;
}
</style>
